import globalize from './internal/globalize';
export default globalize('params', {});
